import { env } from '@/shared/config';

const ADOBE_LAUNCH_SRC = 'https://assets.adobedtm.com/175f7caa2b90/fbbde6698c63/launch-cade79d5fa8d.min.js';
const PT_ENGINE_ACCOUNT = '27744789';
const PT_ENGINE_SRC = `https://js.ptengine.cn/${PT_ENGINE_ACCOUNT}.js`;

export const analyticsConfig = {
  googleAnalytics: {
    enabled: env.isUs && env.hasGaMeasurementId,
    measurementId: env.gaMeasurementId || null,
  },
  adobeLaunch: {
    enabled: !env.isDevelopmentMode,
    src: ADOBE_LAUNCH_SRC,
  },
  ptEngine: {
    enabled: env.isCn,
    accountId: PT_ENGINE_ACCOUNT,
    src: PT_ENGINE_SRC,
  },
} as const;
